import { useEffect, useRef, useState } from "react";
import CommonTable from "../../../components/comman/CommonTable";
import MainHeading from "../../../components/comman/MainHeading";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { callApi } from "../../../ApiHelper/ApiHelper";
import moment from "moment";
import {
  calculateHours,
  checkUserAccess,
  formatTo12HourTime,
} from "../../../utility/CommonFunctions";
import { toast } from "react-toastify";
import FilterComponent from "../../../components/comman/FilterComponent";
import { useDispatch, useSelector } from "react-redux";
import { updateFiltersStates } from "../../../store/actions/UserActions";

export default function TeamExtraWork() {
  const userDetails = useSelector((state) => state.root.userDetails);
  const dispatch = useDispatch();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [state, setState] = useState({
    officeList: null,
    userList: null,
    attendanceList: [],
  });
  const [pageStates, setPageStates] = useState({
    siteId: filterDetails?.siteId,
    activeTab: 1,
    staffType: "0",
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    searchQuery: "",
    tableLoader: false,
    attendanceStatus: "",
    attendanceType: "",
    sortByDate: [
      moment().subtract(1, "month").format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
    ],
    officeName: "",
    user: "",
    siteList: [],
    isInitial: true,
    isLoadingSite: false,
  });
  const timeoutId = useRef(null);

  useEffect(() => {
    getSite();
  }, []);

  useEffect(() => {
    GetAttendance();
  }, [
    pageStates?.sortByDate,
    pageStates?.currentPage,
    pageStates.user,
    pageStates?.searchQuery,
    filterDetails.siteId,
    pageStates?.staffType,
    pageStates.pageSize,
    filterDetails?.orderBy,
  ]);
  const toggleTab = (tab) => {
    if (tab == 1) {
      setPageStates((prev) => ({
        ...prev,
        staffType: "1",
        activeTab: tab,
        currentPage: 1,
      }));
      // GetOfficeList();
    } else {
      setPageStates((prev) => ({
        ...prev,
        staffType: "0",
        activeTab: tab,
        currentPage: 1,
      }));
      getSite();
    }
  };
  const GetAttendance = (pageNo) => {
    let options = {
      method: "GET",
    };
    const Url =
      apiUrl.get_extra_work +
      "?" +
      MainFilterHandler({ ...pageStates, orderBy: filterDetails?.orderBy });
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.extraWork?.map((item) => ({
          ...item,
          empNameWithImage: item?.user?.name + "##" + item?.user?.profilePhoto,
          startDate: moment(item?.startDate).format("DD/MM/YYYY"),
          endDate: moment(item?.endDate).format("DD/MM/YYYY"),
          departmentName: item?.user?.department?.name,
          officeName: item?.user?.site?.name,
          siteName: item?.user?.usersites?.[0]?.site?.name,
          startTime: item?.startDate && formatTo12HourTime(item?.startDate),
          endTime: item?.endDate && formatTo12HourTime(item?.endDate),
          totalDuration:
            item?.startDate && calculateHours(item?.startDate, item?.endDate),
        }));
        setState((pre) => ({
          ...pre,
          attendanceList: newData,
        }));
        setPageStates((pre) => ({
          ...pre,
          count: res?.data?.pageInfo?.total,
          totalPages: res?.data?.pageInfo?.totalPages,
        }));
      }
    });
  };

  const getSite = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      const API =
        apiUrl?.get_user_site +
        `?pageSize=100` +
        (companyId ? `&companyId=${companyId}` : "") +
        (searchQuery ? `&search=${searchQuery}` : "");

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item.site?.id,
              label: item?.site?.name,
            }));

            const siteId = response.data?.site?.some(
              (item) => item.site?.id == filterDetails?.siteId
            );

            setPageStates((prev) => ({
              ...prev,
              ...(siteId ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  // const getSiteUser = (type, siteName) => {
  //   const option = {
  //     method: "GET",
  //   };
  //   const url =
  //     type === "office"
  //       ? apiUrl.get_office + `?officeId=${siteName}`
  //       : apiUrl.site_users + `?siteId=${siteName}`;
  //   callApi(url, option).then((res) => {
  //     if (res?.status === true) {
  //       setState((pre) => ({ ...pre, userList: res.data?.user || res?.data }));
  //       setPageStates((pre) => ({
  //         ...pre,
  //         ...(type === "office"
  //           ? { officeName: siteName }
  //           : { siteId: siteName }),
  //       }));
  //     } else {
  //       toast.error(res?.message);
  //     }
  //   });
  // };

  // const GetOfficeList = () => {
  //   getSiteUser("office", userDetails?.officeId);
  // };

  const TableHeadingOffice = [
    { value: "index", label: "SR NO." },
    { value: "empNameWithImage", label: "Employee" },
    { value: "attendanceDate", label: "Date" },
    { value: "shiftTime", label: "Shift" },
    { value: "departmentName", label: "Department" },
    { value: "officeName", label: "Office" },
    { value: "attendanceType", label: "Attendance Type" },
    { value: "attendanceStatus", label: "Status" },
    { value: "checkIn", label: "Check In" },
    { value: "checkOut", label: "Check Out" },
    { value: "totalDuration", label: "Total Duration" },
  ];

  const TableHeadingSite = [
    { value: "index", label: "SR NO." },
    { value: "empNameWithImage", label: "Employee" },
    { value: "attendanceDate", label: "Date" },
    { value: "shiftTime", label: "Shift" },
    { value: "departmentName", label: "Department" },
    { value: "siteName", label: "Site" },
    { value: "attendanceType", label: "Attendance Type" },
    { value: "attendanceStatus", label: "Status" },
    { value: "checkIn", label: "Check In" },
    { value: "checkOut", label: "Check Out" },
    { value: "totalDuration", label: "Total Duration" },
  ];

  const TableHeading = [
    { value: "index", label: "SR NO." },
    { value: "empNameWithImage", label: "Employee" },
    { value: "departmentName", label: "Department" },
    { value: "siteName", label: "Site" },
    { value: "startDate", label: "Start Date" },
    { value: "startTime", label: "Start Time" },
    { value: "endDate", label: "End Date" },
    { value: "endTime", label: "End Time" },
    { value: "totalDuration", label: "Total Duration" },
  ];

  // useEffect(() => {
  //     if (pageStates?.activeTab === 2 && checkUserAccess(userDetails).isUserAccess) {
  //         getSite();
  //     } else if (!checkUserAccess(userDetails).isUserAccess) {
  //         getSite();
  //     }
  // }, []);

  // useEffect(() => {
  //     if (pageStates.activeTab === 1 && checkUserAccess(userDetails).isUserAccess) {
  //         GetOfficeList();
  //     }
  // }, [pageStates.officeName]);

  const PageChangeHandler = (PageNo) => {
    // console.log("PageChangeHandler", PageNo);
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  const handleChangePageSize = (value) => {
    setPageStates((prev) => ({
      ...prev,
      pageSize: value,
      currentPage: 1,
    }));
  };

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      setPageStates((prevState) => ({
        ...prevState,
        sortByDate: formattedDate,
      }));
    } else {
      setPageStates((prevState) => ({ ...prevState, sortByDate: "" }));
    }
  };

  const handleData = (data, type) => {
    // console.log(data);
    setPageStates((pre) => ({
      ...pre,
      ...(!type && { user: data?.user }),
      ...(!type && { attendanceStatus: data?.attendanceStatus }),
      ...(!type && { attendanceType: data?.attendanceType }),
      ...(type == "site" && { siteId: data?.site }),
      ...(type && { officeName: data?.office }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type == "site" && { siteId: data?.site }),
      })
    );
  };

  const sortList = {
    // userList: state?.userList,
    attendanceStatus: [
      { value: "", label: "Select Attendance Status" },
      { value: 1, label: "Present" },
      { value: 0, label: "Absent" },
      { value: 2, label: "Pending" },
      { value: 3, label: "On Leave" },
    ],
    attendanceType: [
      { value: "", label: "Select Attendance Type" },
      { value: "odRequest", label: "OD Request" },
      { value: "arRequest", label: "AR equest" },
      { value: "general", label: "General" },
      { value: "leave", label: "Leave" },
    ],
    ...(pageStates.activeTab === 2 && { site: pageStates?.siteList }),
  };

  const sortListTwo = {
    // userList: state?.userList,
    site: pageStates?.siteList,
    isShow: true,
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 500);
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  //   console.log("teamExtraWork==========>", state?.attendanceList);

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Team Extra Work"}
          dateChangeHandler={dateChangeHandler}
          showDefaultDate={true}
        // buttonText={"Apply Leave"}
        // buttonIcon={<PlusIcon />}
        // buttonLink={RoutesLink?.add_customer}
        // clickHandler={toggleModal}
        />
        <div className="card mb-4">
          <div className="card-body">
            <FilterComponent
              handleSearch={handleSearchChange}
              // exportBtn={true}
              filterArray={sortListTwo}
              pageStates={pageStates}
              // leaveList={state?.siteList}
              handleData={handleData}
              sortHandler={handleData}
              orderByHandler={orderByHandler}
              orderByList={orderByList}
              getSite={getSite}
            />
            <CommonTable
              TableHeading={TableHeading}
              TableData={state?.attendanceList}
              // ActionData={ActionData}
              currentPage={pageStates?.currentPage}
              PageChangeHandler={PageChangeHandler}
              isLoading={pageStates?.tableLoader}
              totalPages={pageStates?.totalPages}
              count={pageStates?.count}
              handleChangePageSize={handleChangePageSize}
              pageSize={pageStates.pageSize}
            />
          </div>
        </div>
        {/* {checkUserAccess(userDetails).isUserAccess ?
                    <>
                        <div className="card mb-4">
                            <div className="card-body">
                                <div className="wizard-tabs">
                                    <Nav tabs className="nav nav-pills">
                                        <NavItem className="nav-item">
                                            <NavLink
                                                className={pageStates?.activeTab === 1 ? "active" : ""}
                                                style={{ cursor: "pointer" }}
                                                onClick={() => toggleTab(1)}
                                            >
                                                Office Staff Attendance
                                            </NavLink>
                                        </NavItem>
                                        <li className="nav-item">
                                            <div className="border-top-item" />
                                        </li>
                                        <NavItem className="nav-item ">
                                            <NavLink
                                                className={pageStates?.activeTab === 2 ? "active" : ""}
                                                style={{ cursor: "pointer" }}
                                                onClick={() => toggleTab(2)}
                                            >
                                                <h5>Site Staff Attendance</h5>
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </div>
                            </div>
                        </div>
                        <TabContent activeTab={pageStates?.activeTab}>
                            <TabPane tabId={1}>
                                <Fade in={pageStates?.activeTab === 1} timeout={200}>
                                    <div className="card mb-4">
                                        <div className="card-body">
                                            <FilterComponent
                                                handleSearch={handleSearchChange}
                                                // exportBtn={true}
                                                filterArray={sortList}
                                                pageState={pageStates}
                                                // leaveList={state?.siteList}
                                                handleData={handleData}
                                                sortHandler={handleData}
                                            />
                                            <CommonTable
                                                TableHeading={TableHeadingOffice}
                                                TableData={state?.attendanceList}
                                                currentPage={pageStates?.currentPage}
                                                PageChangeHandler={PageChangeHandler}
                                                isLoading={pageStates?.tableLoader}
                                                totalPages={pageStates?.totalPages}
                                                count={pageStates?.count}
                                            />
                                        </div>
                                    </div>
                                </Fade>
                            </TabPane>
                            <TabPane tabId={2}>
                                <Fade in={pageStates?.activeTab === 2} timeout={200}>
                                    <div className="card mb-4">
                                        <div className="card-body">
                                            <FilterComponent
                                                // handleFilter={setPageStates}
                                                handleSearch={handleSearchChange}
                                                // exportBtn={true}
                                                filterArray={sortList}
                                                leaveList={state?.siteList}
                                                pageState={pageStates}
                                                // dateChangeHandler={dateChangeHandler}
                                                // handleFilterForAttendance={dateChangeHandler}
                                                handleData={handleData}
                                                sortHandler={handleData}
                                            />
                                            <CommonTable
                                                TableHeading={TableHeadingSite}
                                                TableData={state?.attendanceList}
                                                // CustomActionData={CustomActionData}
                                                currentPage={pageStates?.currentPage}
                                                PageChangeHandler={PageChangeHandler}
                                                isLoading={pageStates?.tableLoader}
                                                totalPages={pageStates?.totalPages}
                                                count={pageStates?.count}
                                            />
                                        </div>
                                    </div>
                                </Fade>
                            </TabPane>
                        </TabContent>
                    </>
                    : <div className="card mb-4">
                        <div className="card-body">
                            <FilterComponent
                                handleSearch={handleSearchChange}
                                // exportBtn={true}
                                filterArray={sortListTwo}
                                pageState={pageStates}
                                // leaveList={state?.siteList}
                                handleData={handleData}
                                sortHandler={handleData}
                            />
                            <CommonTable
                                TableHeading={TableHeading}
                                TableData={state?.attendanceList}
                                // ActionData={ActionData}
                                currentPage={pageStates?.currentPage}
                                PageChangeHandler={PageChangeHandler}
                                isLoading={pageStates?.tableLoader}
                                totalPages={pageStates?.totalPages}
                                count={pageStates?.count}
                            />
                        </div>
                    </div>
                    } */}
      </div>
    </>
  );
}
